"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrapper = void 0;
const components_1 = require("utils/components");
const react_1 = __importDefault(require("react"));
require("./fieldWrapper.scss");
const react_bootstrap_1 = require("react-bootstrap");
const classnames_1 = __importDefault(require("classnames"));
const FieldWrapper = ({ fieldState, children, loading, fullWidth, }) => {
    return (react_1.default.createElement("div", { className: "d-flex align-items-center" },
        react_1.default.createElement("div", { className: "flex-grow-1" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("field-body", { "mw-100": fullWidth }) },
                react_1.default.createElement("div", { className: "field" }, children)),
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) && (react_1.default.createElement("div", { className: "field-error-message" },
                react_1.default.createElement(components_1.ErrorMessage, { error: fieldState.error })))),
        loading && (react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", role: "status", size: "sm", className: "ms-2" }))));
};
exports.FieldWrapper = FieldWrapper;
